/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAppCoreEnumsAuth0Roles } from './ControlAppCoreEnumsAuth0Roles';
import {
    ControlAppCoreEnumsAuth0RolesFromJSON,
    ControlAppCoreEnumsAuth0RolesFromJSONTyped,
    ControlAppCoreEnumsAuth0RolesToJSON,
} from './ControlAppCoreEnumsAuth0Roles';
import type { ControlAppSchemasUserClientResponse } from './ControlAppSchemasUserClientResponse';
import {
    ControlAppSchemasUserClientResponseFromJSON,
    ControlAppSchemasUserClientResponseFromJSONTyped,
    ControlAppSchemasUserClientResponseToJSON,
} from './ControlAppSchemasUserClientResponse';
import type { ControlDeletedByResponse } from './ControlDeletedByResponse';
import {
    ControlDeletedByResponseFromJSON,
    ControlDeletedByResponseFromJSONTyped,
    ControlDeletedByResponseToJSON,
} from './ControlDeletedByResponse';
import type { ControlLocale } from './ControlLocale';
import {
    ControlLocaleFromJSON,
    ControlLocaleFromJSONTyped,
    ControlLocaleToJSON,
} from './ControlLocale';
import type { ControlUserContactInfoResponse } from './ControlUserContactInfoResponse';
import {
    ControlUserContactInfoResponseFromJSON,
    ControlUserContactInfoResponseFromJSONTyped,
    ControlUserContactInfoResponseToJSON,
} from './ControlUserContactInfoResponse';

/**
 * 
 * @export
 * @interface ControlDeletedUserResponse
 */
export interface ControlDeletedUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    updated: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    registered?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    registry_ip_address?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    last_login?: string;
    /**
     * 
     * @type {ControlLocale}
     * @memberof ControlDeletedUserResponse
     */
    locale?: ControlLocale;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDeletedUserResponse
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlDeletedUserResponse
     */
    policies?: Array<string>;
    /**
     * 
     * @type {ControlAppSchemasUserClientResponse}
     * @memberof ControlDeletedUserResponse
     */
    client: ControlAppSchemasUserClientResponse;
    /**
     * 
     * @type {ControlUserContactInfoResponse}
     * @memberof ControlDeletedUserResponse
     */
    user_contact_info?: ControlUserContactInfoResponse;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDeletedUserResponse
     */
    policyholder?: boolean;
    /**
     * 
     * @type {Array<ControlAppCoreEnumsAuth0Roles>}
     * @memberof ControlDeletedUserResponse
     */
    roles?: Array<ControlAppCoreEnumsAuth0Roles>;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    deleted_on?: string;
    /**
     * 
     * @type {ControlDeletedByResponse}
     * @memberof ControlDeletedUserResponse
     */
    deleted_by?: ControlDeletedByResponse;
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedUserResponse
     */
    deleted_reason?: string;
}

/**
 * Check if a given object implements the ControlDeletedUserResponse interface.
 */
export function instanceOfControlDeletedUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "client" in value;

    return isInstance;
}

export function ControlDeletedUserResponseFromJSON(json: any): ControlDeletedUserResponse {
    return ControlDeletedUserResponseFromJSONTyped(json, false);
}

export function ControlDeletedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDeletedUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'email': json['email'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'created': json['created'],
        'updated': json['updated'],
        'registered': !exists(json, 'registered') ? undefined : json['registered'],
        'registry_ip_address': !exists(json, 'registry_ip_address') ? undefined : json['registry_ip_address'],
        'last_login': !exists(json, 'last_login') ? undefined : json['last_login'],
        'locale': !exists(json, 'locale') ? undefined : ControlLocaleFromJSON(json['locale']),
        'active': json['active'],
        'policies': !exists(json, 'policies') ? undefined : json['policies'],
        'client': ControlAppSchemasUserClientResponseFromJSON(json['client']),
        'user_contact_info': !exists(json, 'user_contact_info') ? undefined : ControlUserContactInfoResponseFromJSON(json['user_contact_info']),
        'policyholder': !exists(json, 'policyholder') ? undefined : json['policyholder'],
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(ControlAppCoreEnumsAuth0RolesFromJSON)),
        'deleted_on': !exists(json, 'deleted_on') ? undefined : json['deleted_on'],
        'deleted_by': !exists(json, 'deleted_by') ? undefined : ControlDeletedByResponseFromJSON(json['deleted_by']),
        'deleted_reason': !exists(json, 'deleted_reason') ? undefined : json['deleted_reason'],
    };
}

export function ControlDeletedUserResponseToJSON(value?: ControlDeletedUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'phone': value.phone,
        'created': value.created,
        'updated': value.updated,
        'registered': value.registered,
        'registry_ip_address': value.registry_ip_address,
        'last_login': value.last_login,
        'locale': ControlLocaleToJSON(value.locale),
        'active': value.active,
        'policies': value.policies,
        'client': ControlAppSchemasUserClientResponseToJSON(value.client),
        'user_contact_info': ControlUserContactInfoResponseToJSON(value.user_contact_info),
        'policyholder': value.policyholder,
        'roles': value.roles === undefined ? undefined : ((value.roles as Array<any>).map(ControlAppCoreEnumsAuth0RolesToJSON)),
        'deleted_on': value.deleted_on,
        'deleted_by': ControlDeletedByResponseToJSON(value.deleted_by),
        'deleted_reason': value.deleted_reason,
    };
}

